import { protectedAxios } from '@/lib/axiosInstance';
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  DeleteAccountRequest,
  DeleteAccountResponse,
  GetAccountSettingsResponse,
  GetAvatarUploadUrlResponse,
  UpdateAccountSettingsRequest,
  UpdateAccountSettingsResponse,
} from '@/types/api/account-settings';

export const getAccountSettings =
  async (): Promise<GetAccountSettingsResponse> => {
    const response =
      await protectedAxios.get<GetAccountSettingsResponse>('/user/profile');

    return response.data;
  };

export const updateAccountSettings = async (
  payload: UpdateAccountSettingsRequest
): Promise<UpdateAccountSettingsResponse> => {
  const response = await protectedAxios.patch<UpdateAccountSettingsResponse>(
    '/user/profile',
    payload
  );

  return response.data;
};

export const deleteAccount = async (
  payload: DeleteAccountRequest
): Promise<DeleteAccountResponse> => {
  const response = await protectedAxios.delete<DeleteAccountResponse>(
    '/user/account',
    {
      data: payload,
    }
  );

  return response.data;
};

export const changePassword = async (
  payload: ChangePasswordRequest
): Promise<ChangePasswordResponse> => {
  const response = await protectedAxios.patch<ChangePasswordResponse>(
    '/user/change-password',
    payload
  );

  return response.data;
};

export const getAvatarUploadUrl = async (
  fileType: string
): Promise<GetAvatarUploadUrlResponse> => {
  const response = await protectedAxios.get<GetAvatarUploadUrlResponse>(
    `/user/profile-picture/presigned-url?fileType=${fileType.split('/')[1]}`
  );

  return response.data;
};

export const uploadToS3 = async (url: string, file: File): Promise<void> => {
  await fetch(url, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
};
